export default "__VITE_ASSET__BZU0V6hE__"